class _Vita_Video_Banner {
    constructor(sectionId) {
      this.sectionId = sectionId;
      this.initVideo();
      this.video_el?.addEventListener('loadedmetadata', () => {
  
      });
      this.video_el?.addEventListener('playing', () => {
        this.hideReplayIcon();
      });
      this.video_el?.addEventListener('pause', () => {
        this.showReplayIcon();
      });
      this.replay_el?.addEventListener('click', () => {
        if (this.video_el && this.video_el.paused) {
          this.video_el.play();
        }
      })
    }
    initVideo() {
      if (window.matchMedia('(max-width: 768px)').matches) {
        this.replay_el = document.querySelector(`.section-${this.sectionId} .mobile-media .vvb-replay-icon`);
        this.video_el = document.getElementById(`vvb-video-mb_${this.sectionId}`);
      } else {
        this.replay_el = document.querySelector(`.section-${this.sectionId} .pc-media .vvb-replay-icon`);
        this.video_el = document.getElementById(`vvb-video-pc_${this.sectionId}`);
      }
    }
    showReplayIcon() {
      this?.replay_el?.classList?.remove('hide');
    }
    hideReplayIcon() {
      this?.replay_el?.classList?.add('hide');
    }
  }